import { createRoot } from 'react-dom/client'
import { App } from './app'
import { mountDaycareApp } from './sharepoint/mount'
import './styles/tokens.css'
import './styles/app.css'

declare global {
  interface Window {
    MyADC?: {
      App: typeof App
      mountDaycareApp: typeof mountDaycareApp
      createRoot: typeof createRoot
    }
  }
}

// The SPFx host evaluates this production IIFE and mounts the app through this
// explicit global. Keeping the assignment as a side effect prevents Rollup from
// tree-shaking the SharePoint entry point.
if (typeof window !== 'undefined') {
  window.MyADC = { App, mountDaycareApp, createRoot }
}

const el = document.getElementById('app')
if (el) {
  mountDaycareApp(el)
}

export { App, mountDaycareApp, createRoot }
